'use client';

import { JobForm } from '@/components/admin/careers/JobForm';

export default function AdminCareerNewPage() {
  return <JobForm />;
}
